import { STORE_DETAILS, RESET_DETAILS } from '../actions/details';

const details = (state = null, action) => {
  switch (action.type) {
    case STORE_DETAILS:
      return {
        ...state,
        ...action.details,
      };

    case RESET_DETAILS:
      return null;

    default:
      return state;
  }
};

export default details;
